// 存放登录相关网络请求
import request from "@/utils/request.js"

export const getPicCode = () => {
    return request.get("captcha/image")
}


// 获取手机验证码
export const getMsgCode = (captchaCode, captchaKey, mobile) => {
    return request.post('/captcha/sendSmsCaptcha',
        {
            form: {
                captchaCode: captchaCode,
                captchaKey: captchaKey,
                mobile: mobile
            }
        }
    )
}

// 登录
// 验证码登录
export const codeLogin = (mobile, smsCode) => {
    return request.post('/passport/login', {
      form: {
        isParty: false,
        mobile,
        partyData: {},
        smsCode
      }
    })
  }